import { Type } from 'class-transformer'
import * as _ from 'lodash'

import { BaseDto } from './base.dto'
import { FileDto } from './file.dto'
import { PagingDto } from './paging.dto'
import { TranslationDto } from './translation.dto'

export class FindProductCategoryDto {
  searchText?: string
  mallId?: string
}

export class FindChildrenProductCategoryDto extends PagingDto {
  searchText?: string
}

export class ProductCategoryDto extends BaseDto {
  name?: TranslationDto
  level?: number
  hasChildren?: boolean
  description?: TranslationDto
  parentId?: string
  mallId?: string
  numberOfViews?: number
  link?: string

  @Type(() => FileDto)
  mobileImage?: FileDto

  @Type(() => FileDto)
  image?: FileDto

  @Type(() => FileDto)
  banner?: FileDto

  @Type(() => ProductCategoryDto)
  children?: ProductCategoryDto[]

  @Type(() => ProductCategoryDto)
  parent?: ProductCategoryDto

  static create({ id, name, parentId, image, description, banner, link, mobileImage, mallId }: ProductCategoryDto) {
    return _.assign<ProductCategoryDto>({
      id: id || null,
      name: name || TranslationDto.create(),
      description: description || TranslationDto.create(),
      parentId: parentId || null,
      image: image || null,
      mobileImage: mobileImage || null,
      mallId: mallId || null,
      banner: banner || null,
      link: link || null
    })
  }
}

export class UpdateProductCategoryDto {
  name?: TranslationDto
  imageId?: string
  mobileImageId?: string
  mallId?: string
  bannerId?: string
  link?: string
}

export class CreateProductCategoryDto {
  name: TranslationDto
  parentId?: string
  imageId?: string
  mobileImageId?: string
  mallId?: string
  bannerId?: string
  link?: string
}